module.exports = __webpack_public_path__ + "img/lecriture.c0d3345c.png";